import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import ComponentBase, { addAllEventsOnGraphic, removeAllEventsFromGraphic, _mapSubFnForward } from './component-base';

var UNDEF,
    addEventOnAllGraphics = function addEventOnAllGraphics(a, b, c) {
  var d;
  b && c && (d = function d(a) {
    a.on && a.on(b, c);
  }, _mapSubFnForward(a.getGraphicalElement(), d), _mapSubFnForward(a.getChildContainer(), d));
},
    removeEventFromAllGraphics = function removeEventFromAllGraphics(a, b, c) {
  var d;
  b && c && (d = function d(a) {
    a.off && a.off(b, c);
  }, _mapSubFnForward(a.getGraphicalElement(), d), _mapSubFnForward(a.getChildContainer(), d));
};

var ComponentInterface =
/*#__PURE__*/
function (_ComponentBase) {
  _inherits(ComponentInterface, _ComponentBase);

  function ComponentInterface() {
    var _this;

    _classCallCheck(this, ComponentInterface);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ComponentInterface).call(this));

    var a = _assertThisInitialized(_assertThisInitialized(_this));

    a._components = {}, a.fireEvent('instantiated'), a.__setDefaultConfig();
    return _this;
  }

  _createClass(ComponentInterface, [{
    key: "addGraphicalElement",
    value: function addGraphicalElement(a, b, c, d) {
      var e = this._graphics;
      return c = c || !1, b && (c ? (e[a] === UNDEF && (e[a] = []), d ? e[a][d] = b : e[a].push(b)) : (e[a] = b, this.fireEvent('graphicalelementattached', {
        element: b
      })), addAllEventsOnGraphic(b, this._middleListeners, this)), b;
    }
  }, {
    key: "removeGraphicalElement",
    value: function removeGraphicalElement(a) {
      var b,
          c = this,
          d = c._graphics;
      _mapSubFnForward(d, function (e, f, g) {
        e === a && (b = !0, removeAllEventsFromGraphic(e, c._middleListeners), c._setRemoveAnim(e, f), g === UNDEF ? delete d[f] : d[f].splice(g, 1));
      }), b && this.fireEvent('graphicalelementremoved', {
        element: a
      });
    }
  }, {
    key: "getGraphicalElement",
    value: function getGraphicalElement(a) {
      return 'undefined' == typeof a ? this._graphics : this._graphics[a];
    }
  }, {
    key: "addChildContainer",
    value: function addChildContainer(a, b) {
      var c = this,
          d = c._childContainers;
      return b && (d === UNDEF && (d = c._childContainers = {}), d[a] = b, addAllEventsOnGraphic(b, c._middleListeners, c)), b;
    }
  }, {
    key: "removeChildContainer",
    value: function removeChildContainer(a) {
      var b = this,
          c = b._childContainers;
      c && c[a] && (removeAllEventsFromGraphic(c[a], b._middleListeners), b._setRemoveAnim(c[a], a), delete c[a]);
    }
  }, {
    key: "getChildContainer",
    value: function getChildContainer(a) {
      return this._childContainers === UNDEF && (this._childContainers = {}), a ? this._childContainers[a] : this._childContainers;
    }
  }, {
    key: "addContainer",
    value: function addContainer(a, b) {
      var c = this._containers;
      return b && (c === UNDEF && (c = this._containers = {}), c[a] = b), b;
    }
  }, {
    key: "removeContainer",
    value: function removeContainer(a) {
      var b = this,
          c = b._containers;
      c && c[a] && (b._setRemoveAnim(c[a], a), delete c[a]);
    }
  }, {
    key: "getContainer",
    value: function getContainer(a) {
      return this._containers === UNDEF && (this._containers = {}), a ? this._containers[a] : this._containers;
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(a, b, c) {
      var d = _get(_getPrototypeOf(ComponentInterface.prototype), "addEventListener", this).call(this, a, b, c);

      return !0 === d ? (addEventOnAllGraphics(this, a, this._middleListeners[a]), b) : !!d && b;
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(a, b) {
      _get(_getPrototypeOf(ComponentInterface.prototype), "removeEventListener", this).call(this, a, b) && removeEventFromAllGraphics(this, a, this._middleListeners[a]);
    }
  }, {
    key: "_dispose",
    value: function _dispose() {
      var a,
          b = this;

      if (_get(_getPrototypeOf(ComponentInterface.prototype), "_dispose", this).call(this)) {
        for (a in b.getFromEnv('paper') && !b.getFromEnv('paper').removed && (_mapSubFnForward(b.getChildContainer(), b.__instantRemoveFn), _mapSubFnForward(b.getGraphicalElement(), b.__instantRemoveFn), _mapSubFnForward(b.getContainer(), b.__instantRemoveFn)), b) {
          b.hasOwnProperty(a) && delete b[a];
        }

        b.fireEvent('removed');
      }
    }
  }, {
    key: "removingDraw",
    value: function removingDraw() {
      var a = this;
      _mapSubFnForward(a.getChildContainer(), a._setRemoveAnim), _mapSubFnForward(a.getGraphicalElement(), a._setRemoveAnim), _mapSubFnForward(a.getContainer(), a._setRemoveAnim);
    }
  }, {
    key: "attachChild",
    value: function attachChild(a, b, c) {
      var d = b || a.getType(),
          e = this._components;
      return !1 === c ? e[d] = a : (!(e[d] && e[d] instanceof Array) && (e[d] = []), e[d].push(a)), a._setLinkedParent(this), this.fireEvent('childattached', {
        attachedChild: a
      }), a;
    }
  }, {
    key: "getChild",
    value: function getChild(a) {
      var b,
          c = this._components;
      return a === UNDEF ? c : (this._searchChildren(a, function (a) {
        b = a;
      }), b);
    }
  }, {
    key: "_searchChildren",
    value: function _searchChildren(a, b) {
      var c,
          d,
          e,
          f = this._components;

      for (d in f) {
        if (f.hasOwnProperty(d)) if (c = f[d], c.constructor === Array) {
          for (e = c.length - 1; 0 <= e; e--) {
            if (c[e].getId && c[e].getId() === a) return b(c[e], e, c);
          }
        } else if (c.getId && c.getId() === a) return b(d, UNDEF, f);
      }
    }
  }, {
    key: "getChildren",
    value: function getChildren(a) {
      return a ? this._components[a] : this._components;
    }
  }]);

  return ComponentInterface;
}(ComponentBase);

export default ComponentInterface;